import React from 'react';
import Navbar from '../components/Navbar';
import Process from '../components/Process';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import SEOHelmet from '../components/SEOHelmet';
import { pagesSEO } from '../utils/seoConfig';

const ProcessPage = () => {
  return (
    <div className="process-page">
      <SEOHelmet 
        title={pagesSEO.process.title}
        description={pagesSEO.process.description}
        keywords={pagesSEO.process.keywords}
        canonical={pagesSEO.process.canonical}
      />
      <Navbar />
      <Breadcrumb />
      <main>
        <h1 className="page-title sr-only">設計流程 - 聯漢室內設計工作室</h1>
        <Process />
      </main>
      <Footer />
    </div>
  );
};

export default ProcessPage; 